module.exports = __webpack_public_path__ + "static/media/no-timesheet.c1ed1cef.svg";